import React from 'react';
import './referral-popup.css';
import { useTranslation } from 'react-i18next';

const ReferralPopup = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                text: t('menu.join_me'),
                url: `https://app.lifise.io/`,
                title: t('menu.join_me'),
            });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="referral-popup-overlay" onClick={onClose}>
            <div className="referral-popup-content" onClick={e => e.stopPropagation()}>
                <div className="referral-popup-close" onClick={onClose}>×</div>
                
                <div className="referral-popup-header">
                    <div className="referral-popup-icon">🎁</div>
                    <h2>{t('menu.referral_rewards')}</h2>
                </div>
                
                <div className="referral-popup-body">
                    <div className="referral-reward-section">
                        <h3>{t('menu.sponsor_benefits')}</h3>
                        <div className="reward-item">
                            <span className="reward-icon">🪙</span>
                            <span className="reward-text">+7% {t('menu.in_tokens')}</span>
                        </div>
                        <div className="reward-item">
                            <span className="reward-icon">💰</span>
                            <span className="reward-text">+5% {t('menu.in_fiat')}</span>
                        </div>
                    </div>
                    
                    <div className="referral-reward-section">
                        <h3>{t('menu.referred_benefits')}</h3>
                        <div className="reward-item">
                            <span className="reward-icon">🚀</span>
                            <span className="reward-text">{t('menu.referred_bonus')}</span>
                        </div>
                    </div>
                </div>
                
                <div className="referral-popup-footer">
                    {navigator.share && (
                        <button className="referral-share-button" onClick={handleShare}>
                            {t('menu.share')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReferralPopup;